import { CSSProperties, FC, ReactNode } from 'react';
import { Avatar } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { centerComponentInMiddleofView } from '@/utilities';

export interface EmptyViewProps {
    icon: ReactNode;
    height?: CSSProperties['height'];
    label: string | ReactNode;
    description: string | ReactNode;
    extra?: string | ReactNode | null;
    extraStyle?: CSSProperties;
}

export const EmptyView: FC<EmptyViewProps> = ({ icon, label, height, description, extra, extraStyle }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <section style={{ textAlign: 'center', height: height ?? 16 * 24, ...centerComponentInMiddleofView }}>
            <div>
                <Avatar
                    size={16 * 2.5}
                    icon={icon}
                    shape='square'
                    style={{
                        color: token.colorTextQuaternary,
                        background: token.colorFillQuaternary,
                        border: `1px dashed ${token.colorBorder}`,
                        marginBottom: '0.25rem',
                    }}
                />
            </div>
            <div style={{ margin: '0.5rem 0' }}>
                <span style={{ fontWeight: token.fontWeightStrong, color: token.colorTextSecondary }}>{label}</span>
            </div>
            <div style={{ maxWidth: '75%', margin: '0 auto' }}>
                <small style={{ color: token.colorTextTertiary }}>{description}</small>
            </div>
            {extra && <div style={{ marginTop: '1rem', ...extraStyle }}>{extra}</div>}
        </section>
    );
};

export default EmptyView;
